export default __webpack_public_path__ + "24a318525537ac2c4c74c4302ab69481.woff";